import React from 'react';
import PropTypes from 'prop-types';
import { useSetAtom } from 'jotai';
import useSignalR from '../../Services/signalR';
import { notifyCacheRefreshAtom } from '../../Atoms/HubAtoms';

export default function PriorityHubProvider() {
  const setNotifyCacheRefresh = useSetAtom(notifyCacheRefreshAtom);

  useSignalR(`${window.databeasy?.API_URL}hubs/priorityhub`, null, [
    {
      eventName: 'NotifyCacheRefresh',
      callback: () => {
        setNotifyCacheRefresh(Date.now());
      },
    },
  ]);

  return <div />;
}

PriorityHubProvider.propTypes = {
  channel: PropTypes.string.isRequired,
};
